var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIbmFoodtrustLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 318 34.5",
    y: 0,
    x: 0,
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style4226",
    type: "text/css"
  }, "\n        .st0{fill:#373d42}\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68 -81.3)",
    id: "g4228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4230",
    d: "M68 115.3V112h4.5V86.4H68v-3.2h12.8v3.2h-4.5V112h4.5v3.2H68z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4232",
    d: "M86.7 83.2h13.2c5.3 0 8.5 3.3 8.5 8.3 0 4.8-3.1 6.5-5.2 6.8v.3c2.3.1 6.3 2.1 6.3 7.4 0 5.3-3.5 9.3-8.3 9.3H86.7V83.2zm3.9 13.9h8.9c3 0 4.9-1.6 4.9-4.5V91c0-2.8-1.8-4.5-4.9-4.5h-8.9v10.6zm0 14.8h9.5c3.3 0 5.3-1.7 5.3-5v-1.6c0-3.2-2-5-5.3-5h-9.5v11.6z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4234",
    d: "M140.4 88.3h-.2l-2.7 5.4-7.7 13.9-7.6-13.9-2.7-5.3h-.2v26.9h-3.8v-32h5l9.2 17.3h.2l9.2-17.3h5v32h-3.8v-27z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4236",
    d: "M160.8 115.3v-32h20.6v5.4h-14.5v7.8h12.7v5.4h-12.7v13.5h-6.1z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4238",
    d: "M182.7 103.2c0-7.7 4.3-12.5 11.1-12.5 6.9 0 11.1 4.8 11.1 12.5s-4.3 12.6-11.1 12.6-11.1-4.9-11.1-12.6zm16.1 2.3V101c0-3.6-1.9-5.6-5-5.6-3 0-5 2-5 5.6v4.5c0 3.6 1.9 5.6 5 5.6s5-2 5-5.6z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4240",
    d: "M207.4 103.2c0-7.7 4.3-12.5 11.1-12.5 6.9 0 11.1 4.8 11.1 12.5s-4.3 12.6-11.1 12.6-11.1-4.9-11.1-12.6zm16.1 2.3V101c0-3.6-1.9-5.6-5-5.6-3 0-5 2-5 5.6v4.5c0 3.6 1.9 5.6 5 5.6s5-2 5-5.6z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4242",
    d: "M248.6 111.3h-.2c-.9 2.7-3.4 4.5-6.6 4.5-6 0-9.4-4.5-9.4-12.6 0-8 3.3-12.5 9.4-12.5 3.2 0 5.8 1.7 6.6 4.5h.2V81.3h5.9v34h-5.9v-4zm0-4.3v-7.6c0-2.3-2.2-3.9-5-3.9-3 0-5.1 2.2-5.1 5.6v4.1c0 3.4 2.1 5.6 5.1 5.6 2.8.1 5-1.3 5-3.8z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4244",
    d: "M282.7 88.6v26.7h-6.1V88.6h-9.1v-5.4h24.2v5.4h-9z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4246",
    d: "M293.2 115.3v-24h5.9v5h.2c.6-2.5 2.5-5 6.3-5h1.3v5.6H305c-3.9 0-6 1.1-6 3.7v14.7h-5.8z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4248",
    d: "M324.4 111.3h-.2c-.8 2.4-2.8 4.5-6.7 4.5-4.9 0-7.7-3.4-7.7-9.4V91.3h5.9v14.5c0 3.3 1.2 5.1 4 5.1 2.3 0 4.7-1.2 4.7-3.8V91.3h5.9v24h-5.9v-4z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4250",
    d: "M333.8 111.4l3.6-3.5c1.7 2 3.9 3.3 6.6 3.3 2.8 0 4-1.1 4-2.8 0-1.4-.8-2.2-2.9-2.5l-2.4-.3c-5.1-.6-8-2.9-8-7.2 0-4.6 3.6-7.6 9.1-7.6 4.7 0 7.1 1.4 9.4 3.8l-3.4 3.4c-1.4-1.5-3.4-2.6-5.7-2.6-2.5 0-3.6 1-3.6 2.5 0 1.6.9 2.3 3.1 2.7l2.4.3c5.2.7 7.8 3.1 7.8 7.1 0 4.6-3.9 7.8-9.9 7.8-4.7 0-7.7-1.6-10.1-4.4z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4252",
    d: "M364.7 115.3c-4 0-6.2-2.2-6.2-6.1V95.9H355v-4.6h1.8c1.7 0 2.3-.8 2.3-2.5v-4.1h5.3v6.6h4.9v4.6h-4.9v14.6h4.5v4.7h-4.2z",
    className: "st0",
    fill: "#373d42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4254",
    d: "M373.4 96.7v-6.8h-2.7v-1h6.5v1h-2.7v6.8h-1.1zm5.5 0v-7.8h1.3l2.2 4.2h.1l2.2-4.2h1.3v7.8h-1v-6.2h-.1l-2.4 4.6-2.4-4.6h-.1v6.2h-1.1z",
    className: "st0",
    fill: "#373d42"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmFoodtrustLogo);
export default __webpack_public_path__ + "static/media/ibm-foodtrust-logo.772e868a2ab2781f617f984e5d49470a.svg";
export { ForwardRef as ReactComponent };